import {API_HOST_NAME} from "../constants.js";
import useAuthenticatedResources from "../../../useAuthenticatedResources.js";

const useNodeTasksResources = (teamId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/node_tasks`;
  return useAuthenticatedResources(url)
}

export default useNodeTasksResources;
